module Meevo.Plugins.TextelBlast {
	"use strict";

    export class MainSection extends Meevo.Components.CommonClasses.CommonSectionBase {
        private readonly TEXTEL_OUTBOUND_URL_LEGACY: string = 'https://outbound.textel.net/';
        private readonly TEXTEL_OUTBOUND_URL_ACTUAL: string = 'https://app.textel.net/';

        constructor(props: ISectionParamsTextelBlast, protected window: ng.IWindowService) {
            super(
                props.sectionId,
                props.displayNameContentKey,
                props.template,
                props.isPrimarySection,
                props.handlesOwnCrud,
                props.baseEndpoint,
                props.sectionEndpoint,
                props.loggingService,
                props.dataService,
                props.noun,
                props.identityService,
                props.sectionSecurityKey);
        }

        goToTextelBlastPortalLegacy(): void {
            this.window.open(this.TEXTEL_OUTBOUND_URL_LEGACY, '_blank');
        }

        goToTextelBlastPortalActual(): void {
            this.window.open(this.TEXTEL_OUTBOUND_URL_ACTUAL, '_blank');
        }
	}
}
